import React from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import $ from 'jquery';

import constant from '../../constant';
import WithToastContext from '../../context/ToastContext';
import Loader from '../../component/common/Loader';
import Logo from './../../assets/img/logo.png'

import { onChange, validateForm } from '../../utils';
import { resetPassword } from '../../action/_AuthAction';
// import Poster1 from './../../assets/img/Happy family jumping with huge piggybank.jpg'

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        const parsed = queryString.parse(window.location.search);
        const token = parsed.token;

        this.state = {
            token,
            password: { name: 'password', required: true, error: '', value: '', type: constant.fieldType.string },
            showLoader: false
        }
    }

    componentDidMount() {
        document.title = constant.component.resetPassword.title;
        $('body').css('background', '#fff');
    }

    render() {
        const { password, showLoader } = this.state;
        return (
            <div className="container-fluid">
                {
                    showLoader && <Loader />
                }
                <div className="row mt-5">
                    <div className="col-md-4">
                        {/* <img src={Poster1} style={{ height: '80vh' }} alt="" /> */}
                    </div>
                    <div className="col-md-4">
                        <div className="text-center mb-5">
                            <img src={Logo} className="w-50" alt="Capital Plus Residential" />
                        </div>
                        <div className=" b-shadow p-4" style={{ border: '0.1px solid #eeefff' }}>
                            <div className="">
                                <h5>Reset Password</h5>
                                <hr />
                                <form onSubmit={this.onSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">New Password *</label>
                                        <input
                                            type="password"
                                            name={password.name}
                                            onChange={this.onChange}
                                            value={password.value}
                                            className={password.error.length === 0 ? "form-control" : "form-control is-invalid"}
                                        />
                                    </div>
                                    <div className="row mt-3 pt-3">
                                        <div className="col">
                                            <Link to={constant.component.login.url} className="btn btn-link">Back To Login</Link>
                                        </div>
                                        <div className="col-auto">
                                            <button className="btn btn-primary px-5" type="submit">Submit</button>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                        <div className="text-center mt-3">
                            Powered by <a href="https://capitalplusres.com" target="_blank" rel="noreferrer">Loan Tracker USA</a>
                        </div>
                    </div>
                    {/* <div className="col-md-4">
                        <img src={Poster2} style={{ width: '100%' }} />
                    </div> */}
                </div>
            </div>
        );
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            const { token, password } = this.state;
            const model = {
                token,
                password: password.value,
            };
            this.setState({ showLoader: true });
            resetPassword(model).then((res: any) => {
                this.setState({ showLoader: false });
                if (res.error) {
                    this.props.context.toast.error(res.error);
                } else {
                    this.props.context.toast.success('Password was updated successfully. Please visit the login page to continue with new password.');
                    this.props.history.push(constant.component.login.url);
                }
            })
        }
    }
}

export default WithToastContext(withRouter(ComponentName));
